export const STUDENT_WEB_PLATFORM = 'web';

export const getStudentApiHeaders = (token = null) => {
  const authToken = token ?? (typeof window !== 'undefined' ? localStorage.getItem('student_token') : null);
  const headers = {
    'X-Client-Platform': STUDENT_WEB_PLATFORM,
  };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  return headers;
};

export const getStudentApiParams = (params = {}) => ({
  platform: STUDENT_WEB_PLATFORM,
  ...params,
});
